module.exports = __webpack_public_path__ + "img/applicationConstruction-main-3d.78c19d7e.png";